export default __webpack_public_path__ + "static/media/13.4221a48b.jpg";